// extracted by mini-css-extract-plugin
module.exports = {"tag":"UnverifiedTag_tag__17rq8"};